<template>
  <v-container
    class="px-8"
    >
    <v-row class="border mt-6">
      <v-col 
        class="px-4"
        cols="6">
        <span 
          class="text-h5 font-weight-medium">
          {{ $t('contract.show.main_panel.headers.payments')}}
        </span>
      </v-col>
      <v-col 
        class="pr-4"
        cols="6">
        <div
          class="d-flex flex-row align-center justify-end"
          >
          <v-btn
            @click="$router.push({name: 'CreatePropertyTax', id: property.id, query: { objectType: 'Property' }})"
            color="primary">
            {{ $t('action.add_tax') }}
          </v-btn>
        </div>
      </v-col>
      <v-col
        cols="12"
        class="pt-0 px-4"
        v-if="property.taxes.length"
        v-for="tax in property.taxes"
        >
        <tax
          :tax="tax"
          @reload="$emit('reload')"
          ></tax>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Tax from '@/components/taxes/Tax'

export default {
  props: {
    property: {
      required: true,
      type: Object
    }
  },

  components: { Tax } 
}
</script>
